<p-toast position="top-right"></p-toast>
<ng-container *ngIf="isAppLoading; else showApp">
  <div id="initial-loader">
    <img class="w-44 h-44 rounded-full bg-white p-2" src="../../../assets/images/logo-small.svg" alt="Login">
    <div class="scene">
      <div class="dog">
        <div class="dog-body">
          <div class="body"></div>
          <div class="dog-tail"></div>
          <div class="dog-legs leg-front-1"></div>
          <div class="dog-legs leg-front-2"></div>
          <div class="dog-legs leg-back-1"></div>
          <div class="dog-legs leg-back-2"></div>
        </div>
        <div class="dog-head">
          <div class="head"></div>
          <div class="dog-ears ear-left"></div>
          <div class="dog-ears ear-right"></div>
          <div class="dog-eyes eye-right"></div>
          <div class="dog-snout">
            <div class="dog-nose"></div>
            <div class="dog-tongue"></div>
          </div>
        </div>
      </div>
    </div>
    <p class="text-sm font-bold">Bitte warten…</p>
  </div>
</ng-container>

<ng-template #showApp>
  <router-outlet></router-outlet>
</ng-template>
<app-waiting-dialog></app-waiting-dialog>
<p-confirmDialog></p-confirmDialog>
